<script setup lang="ts">
import { defineProps, defineEmits, reactive } from 'vue'

const emit = defineEmits<{
  (e: 'uploaded', payload: { file: File; file_name: string }): void
}>()

const props = defineProps({
  id: { type: String, required: true },
  caption: { type: String, default: '' },
  label: { type: String, default: 'Fichier' }
})

const extensionsAllowed = ['.pdf', '.doc', '.docx', '.xls', '.xlsx']
const formValue = reactive({
  file: null as File | null,
  file_name: ''
})

function onFileUploaded(event: Event) {
  const input = event.target as HTMLInputElement
  if (!input.files || input.files.length === 0) {
    return
  }
  const file = input.files[0]
  formValue.file = file
  formValue.file_name = file.name
  emit('uploaded', {
    file,
    file_name: file.name
  })
}
</script>

<template>
  <label :for="props.id" class="custom-upload my-5" :class="{ active: formValue.file }">
    <div class="custom-upload-st2">
      <input
        :id="props.id"
        class="display-none"
        type="file"
        @change="onFileUploaded"
        :accept="extensionsAllowed.join(',')"
      />
      <div class="s4 custom-upload-img">
        {{ props.caption }}
      </div>
      <div class="s12">
        <span class="custom-upload-text">
          {{ props.label }}
        </span>
        <b class="color-danger">*</b><br />
        <span class="custom-upload-text-sm">
          {{ formValue.file_name ? formValue.file_name : 'Charger le doc' }}
        </span>
      </div>
      <div class="s4 right">
        <img src="/public/icons/icon-upload.svg" class="custom-upload-icon" />
      </div>
    </div>
  </label>
</template>

